// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"wrapper__1UwCE","wrapper-nopadding":"wrapper-nopadding__2h-B_","loading":"loading__1r-QD","error":"error__2nehk","table-loading":"table-loading__3vp7y","empty-val":"empty-val__2KcxI","panelheader-tools":"panelheader-tools__2b7Uc","propsPanels":"propsPanels__gaCt0","new":"new__pG-OR","marginLm":"marginLm__3NYi-","marginRm":"marginRm__2j_cl","fullWidth":"fullWidth__rS05t","fullHeight":"fullHeight__1_vcs","noData":"noData__tucLf","captcha":"captcha__2sd2Z"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/Register/coms/Captcha/styles.scss
// module id = 2317
// module chunks = 1